import React, { useEffect, useState } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderTextField, renderselect } from "../../../../Components/Forms/renders";
import { fechgastenprofiel } from "../../../GastenVerbruik/Reducers/actions";

const InsertForm = ({ handleSubmit, gastenprofielen }) => {
  const dispatch = useDispatch();
  const [gastprofielOptions, setGastprofielOptions] = useState({});

  useEffect(() => {
    dispatch(fechgastenprofiel());
  }, [dispatch]);

  useEffect(() => {
    if (gastenprofielen && gastenprofielen.length > 0) {
      const options = { '': 'Geen gastprofiel gekoppeld' };
      gastenprofielen.forEach(profiel => {
        options[profiel._id] = profiel.naam;
      });
      setGastprofielOptions(options);
    }
  }, [gastenprofielen]);
  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-6">
              <Field name="naam" type="input" validate={[required()]} component={renderField} label="Naam standplaats categorie" />
              <Field name="beschrijving" type="input" component={renderTextField} label="Beschrijving standplaats categorie (optioneel)" />
              <Field 
                name="gastenprofiel" 
                component={renderselect} 
                label="Gekoppeld Gastenprofiel" 
                options={gastprofielOptions}
              />
              <Field name="prijs" type="number" component={renderField} label="Basis prijs (wordt overschreven door gastprofiel)" />
              <Field name="voorschot" type="number" component={renderField} label="Voorschot per nacht" />
            </div>
          </div>
          <div className="pull-left submit">
            <input
              type="submit"
              className="btn btn-next btn-fill btn-success btn-wd btn-mg"
              name="next"
              value="Opslaan"
            />
          </div>
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gastenprofielen: state.gastenverbruik.gastenprofielen,
});

export default connect(mapStateToProps)(
  reduxForm({
    form: "kampeerplaatscategorieinsert",
  })(InsertForm)
);
